module.exports = __webpack_public_path__ + "img/ocpfff.3fcada50.png";